/* eslint-disable jira/filename-case */
import { useCallback } from 'react';
import type { Attributes } from '@atlassian/jira-product-analytics-bridge';
import { isLoaderError } from '@atlassian/react-loosely-lazy/lazy/errors';

export const addChunkLoadErrorAnalyticsAttribute = (error: Error): Attributes => ({
	chunkLoadError: isLoaderError(error),
});

export const useAddErrorBoundaryAnalyticsAttributes = (
	attributes: Attributes = {},
): ((error: Error) => {
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	[x: string]: any;
}) =>
	useCallback(
		(error: Error) => ({
			...attributes,
			...addChunkLoadErrorAnalyticsAttribute(error),
		}),
		[attributes],
	);
